import React from 'react';
import cn from 'clsx';
import { UIHeading1, UIHeading2, useDeviceType } from '@cian/ui-kit';
import { IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';

import styles from './styles.css';

export interface ITitleFormProps {
  children: React.ReactElement | null | string;
}

export const TitleForm: React.FC<ITitleFormProps> = ({ children }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const Heading = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <div className={cn(styles.root, styles[deviceType])} data-testid="form-title">
      <Heading>{children}</Heading>
      {!isDesktop && (
        <div className={cn(styles.icon)}>
          <IconActionFilters16 color="icon-primary-default" />
        </div>
      )}
    </div>
  );
};

TitleForm.displayName = 'TitleForm';
